"use client";
import dynamic from 'next/dynamic';
const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });

import React from "react";
import styles from "./NotFoundPage.module.css";
import Image from "next/image";
import { OnOpenUrl } from "@/Component/accordion";
import errorImg from "@/assets/Icon/Error_Icon.png"
import { useTranslation } from "react-i18next";
import { useRouter } from "next/navigation";
const NotFoundPage = () => {
    const { t } = useTranslation();
    const router = useRouter();
    return (
        <div className={styles.page}>
            <Header />
            <div className={styles.error__container}>
                <Image src={errorImg} alt="Error" className={styles.error__img} />
                <div className={styles.text__content}>
                    <span className={styles.text}> {t("NotFound.Title")} </span>

                </div>
                <div className={styles.home__btn} onClick={() => { OnOpenUrl({ content: { url: "" }, navigate: router }) }}>
                    <span >
                        {t("NotFound.Home")}
                    </span>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default NotFoundPage;